module.exports = __webpack_public_path__ + "static/media/Yellowstar.32440c86.svg";